import { render, staticRenderFns } from "./SocialRecruitmentComp.vue?vue&type=template&id=861318a6&scoped=true&"
import script from "./SocialRecruitmentComp.vue?vue&type=script&lang=js&"
export * from "./SocialRecruitmentComp.vue?vue&type=script&lang=js&"
import style0 from "./SocialRecruitmentComp.vue?vue&type=style&index=0&id=861318a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861318a6",
  null
  
)

export default component.exports